import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import randomstring from 'uuid/v4';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import NavigationPrompt from 'react-router-navigation-prompt';

import Alert from '../../../dialogs/Alert';
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/list.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import { BlueTickIcon, AddIcon } from '../../../../images/icons/WrapSvg';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import List from './List';
import Dialog from './Item';

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

class Catalog extends React.Component {
    state = {
        codigo: randomstring(),
        nombre: '',
        error: '',
        valores: [],
        toDelete: [],
        open: false,
        pending_changes: false,
        catalogs: [
            {
                codigo: 'familiaproducto',
                nombre: this.props.intl.formatMessage({ id: 'familiaproducto' }),
            },
            {
                codigo: 'unidadmedida',
                nombre: this.props.intl.formatMessage({ id: 'unidadmedida' }),
            },
            {
                codigo: 'estacion',
                nombre: this.props.intl.formatMessage({ id: 'estacion' }),
            },
        ],
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.list && nextProps.id) {
            const catalog = this.state.catalogs.find((f) => f.codigo === nextProps.id);
            const arr = nextProps.list
                ? []
                      .concat(nextProps.list)
                      .sort((a, b) => (a.nombre.trim() < b.nombre.trim() ? -1 : 1))
                : [];
            this.setState({
                codigo: nextProps.id,
                nombre: catalog ? catalog.nombre : '',
                valores: arr,
                toDelete: [],
                open: false,
            });
        }
    }

    componentDidUpdate() {
        if (this.isCorrect()) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    handleAdd = (event) => {
        this.setState({ open: true });
    };

    handleClose = (name) => {
        const { pending_changes } = this.state;
        let arr = [...this.state.valores];
        let pending = pending_changes;
        if (name) {
            arr.push({
                nombre: name,
            });
            arr = [].concat(arr).sort((a, b) => (a.nombre.trim() < b.nombre.trim() ? -1 : 1));
            pending = true;
        }
        this.setState({
            open: false,
            valores: arr,
            pending_changes: pending,
        });
    };

    handleDelete = (item) => {
        const arr = [...this.state.valores];
        const index = arr.indexOf(item);
        const arrDelete = [...this.state.toDelete];
        if (item && item.id) {
            arrDelete.push(item.id);
        }
        arr.splice(index, 1);
        this.setState({ valores: arr, toDelete: arrDelete, pending_changes: true });
    };

    isCorrect = () => {
        const { nombre, valores, pending_changes } = this.state;
        return pending_changes && nombre && nombre.length > 3 && valores && valores.length > 0
            ? true
            : false;
    };

    handleSummit = () => {
        const { codigo, valores, toDelete } = this.state;
        this.setState({ pending_changes: false });
        this.props
            .edit(codigo, valores, toDelete)
            .then((r) => {
                this.props.history.push('/xef/catalogs');
            })
            .catch((error) => {
                var intervalId = setInterval(this.timer, 5000);
                this.setState({ intervalId: intervalId, error: error.message.trim() });
            });
    };

    handleTooltipClose = () => {
        this.setState({ error: undefined });
    };

    timer = () => {
        this.setState({ error: undefined });
        clearInterval(this.state.intervalId);
    };

    render() {
        const { nombre, valores, open, selected, pending_changes } = this.state;
        const { list, list_is_loading, list_has_error, intl } = this.props;

        if (list_has_error && list_has_error.hasErrored) {
            return <Error open message={list_has_error.error} handleClose={this.handleBack} />;
        } else if (list === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_catalog_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div
                    className={'flex_full_column padding_bottom_9 padding_top_12 margin_bottom_48'}
                >
                    <NavigationPrompt when={(crntLocation, nextLocation) => pending_changes}>
                        {({ onConfirm, onCancel }) => (
                            <Alert
                                title="alert_dialog_discard_title"
                                text="alert_dialog_discard_message"
                                open={true}
                                onCancel={onCancel}
                                onConfirm={onConfirm}
                            />
                        )}
                    </NavigationPrompt>
                    {list_is_loading && <Loading open opacity />}
                    <div className={'flex_full_column padding_borders'}>
                        <TextField
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            disabled={true}
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className={'flex_full_row'}
                            value={nombre}
                            margin="normal"
                        />
                        <div className="flex_full_row margin_top_32 align_center">
                            <List
                                items={valores}
                                alpha={true}
                                handleDelete={this.handleDelete.bind(this)}
                            />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleAdd.bind(this)}
                            >
                                <AddIcon />
                            </Fab>
                            {open && (
                                <Dialog item={selected} handleClose={this.handleClose.bind(this)} />
                            )}
                            {this.state.error && (
                                <Snackbar
                                    open={true}
                                    text={this.state.error}
                                    onClose={this.handleTooltipClose}
                                    variant="error"
                                />
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Catalog.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        list: state.list,
        list_is_loading: state.list_is_loading,
        list_has_error: state.list_has_error,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Catalog)));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/catalog/Catalog.js